import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import MenuDev from 'app/layouts/MenuDev';
import LoginForm from './components/LoginForm';
import RecoveryForm from './components/RecoveryForm';
import ManualButton from 'app/components/ManualButton';

import { logIn } from 'app/store/slices/user';
import { showLoading, hideLoading, setFromLogin } from 'app/store/slices/settings';

import helpers from 'app/utils/helpers';
import auth from 'app/api/auth';
import notification from 'app/config/notification';
import authEndpoints from 'app/api/services/authEndpoints';

import { URLS } from 'app/config/urls';
import { errorHandler } from 'app/utils/errorHandler';
import { DEV_ENVIRONMENT, SYSTEM_DOC_TYPES } from 'app/utils/constants';

import styles from './styles';
import { updateServiceDetails } from '../../store/slices/services';
import { CHANGE_EMAIL_SERVICE, SERVICES_CODES, SERVICES_PROPERTIES } from '../../config/services';
const useStyles = makeStyles(styles);

function Login(props) {
    const history = useHistory();
    const dispatch = useDispatch();
    const { intl } = props;

    const classes = useStyles();

    const viewLogin = 0;
    const viewRecoverPass = 1;

    const logo = process.env.PUBLIC_URL + '/img/logo-login.png';
    const [index, setIndex] = useState(viewLogin);

    useEffect(() => {
        if (!!auth.getToken()) {
            dispatch(setFromLogin(true));
            history.push(URLS.START);
        }
    }, [dispatch, history]);

    const handleLogIn = async (credentials) => {
        if (!credentials.username || !credentials.password) {
            notification(
                intl.formatMessage({
                    id: 'MESSAGES.LOGIN.MISSING_MANDATORY_INFO_LOGIN',
                }),
                { toastId: 'MISSING_MANDATORY_INFO_LOGIN', type: 'error' },
            );
            return false;
        }

        const userCredentials = { ...credentials };
        if (String(userCredentials.username).indexOf('@') < 0) {
            userCredentials.username = helpers.somenteAlfanumericos(userCredentials.username);
        }

        dispatch(showLoading());
        try {
            const response = await logIn(userCredentials, dispatch);
            if (response) {
                history.push(URLS.COMPANY_SELECT);
            } else {
                notification(intl.formatMessage({ id: 'MESSAGES.LOGIN.USER_NOT_FOUND' }), {
                    toastId: 'USER_NOT_FOUND',
                    type: 'error',
                });
            }
        } catch (err) {
            notification(intl.formatMessage({ id: 'MESSAGES.LOGIN.USER_NOT_FOUND' }), {
                toastId: 'USER_NOT_FOUND',
                type: 'error',
            });
        }
        dispatch(hideLoading());
    };

    const handleRecovery = async (credentials) => {
        if (!credentials.deCpfCnpj || !credentials.deEmail) {
            notification(
                intl.formatMessage({
                    id: 'MESSAGES.LOGIN.MISSING_MANDATORY_INFO_RECOVERY',
                }),
                {
                    toastId: 'MISSING_MANDATORY_INFO_RECOVERY',
                    type: 'error',
                },
            );
            return false;
        }

        const payload = {
            deEmail: credentials.deEmail,
            deCpfCnpj: helpers.somenteAlfanumericos(credentials.deCpfCnpj),
        };

        dispatch(showLoading());
        try {
            const response = await authEndpoints.resetPassword(payload);
            if (response.status === 200) {
                notification(
                    intl.formatMessage({
                        id: 'MESSAGES.LOGIN.RECOVERY_MESSAGE',
                    }),
                    { toastId: 'RECOVERY_MESSAGE', type: 'success' },
                );
            }
            hangleViewToggle(viewLogin);
        } catch (error) {
            errorHandler(error.response?.status, error.response?.data?.message);
        }
        dispatch(hideLoading());
    };

    const handleRegister = async () => {
        dispatch(showLoading());
        dispatch(setFromLogin(true));
        history.push(URLS.START);
        dispatch(hideLoading());
    };
    const handleChangeEmail = async () => {
        dispatch(showLoading());
        dispatch(setFromLogin(true));
        dispatch(updateServiceDetails(CHANGE_EMAIL_SERVICE));
        history.push(SERVICES_PROPERTIES[SERVICES_CODES.CHANGE_EMAIL].url);
        history.push(URLS.CHANGE_EMAIL);
        dispatch(hideLoading());
    };

    const hangleViewToggle = (view) => setIndex(view);

    return (
        <>
            <ManualButton
                rest={{
                    type: SYSTEM_DOC_TYPES.EXTERNO.key,
                }}
                color={'default'}
            />

            <div className={classes.container}>
                <Card className={classes.boxLogin}>
                    <CardContent className={classes.content}>
                        {index !== viewLogin && (
                            <Button className={classes.backButton} onClick={() => hangleViewToggle(viewLogin)}>
                                <KeyboardArrowLeft />
                                <FormattedMessage id="LABELS.COMMONS.BACK" />
                            </Button>
                        )}
                        <img className={classes.logo} src={logo} alt="logo" />
                        {index === viewLogin && (
                            <LoginForm
                                onSubmit={handleLogIn}
                                onRecovery={() => hangleViewToggle(viewRecoverPass)}
                                onRegister={handleRegister}
                                onChangeEmail={handleChangeEmail}
                            />
                        )}
                        {index === viewRecoverPass && <RecoveryForm onRecovery={handleRecovery} />}
                        {process.env.NODE_ENV === 'development' && DEV_ENVIRONMENT && <MenuDev />}
                    </CardContent>
                </Card>
            </div>
        </>
    );
}

export default injectIntl(Login);
